// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/solid/map-pin.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/solid/map-pin'

import { Icon, type IconComponentProps } from '../icon'

export const MapPinIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
